<vitamui-slide-toggle [checked]="checked()" (checkedChange)="onToggle($event)" [disabled]="disabled() || forceDisabled">
  <ng-content></ng-content>
</vitamui-slide-toggle>
